/* eslint-disable react/no-unused-prop-types */
import React, { memo } from 'react'
import { HeadingText } from '@paypalcorp/pp-react'
import { Message } from '@paypalcorp/worldready-react'

const DataPrivacyHeader = memo(() => (
  <div className="dataPrivacy-header">
    <img
      src="https://www.paypalobjects.com/paypal-ui/pictograms/multicolored/svg/privacy.svg"
      alt="accept-cards"
      className="dataPrivacy-image"
    />
    <HeadingText>
      <Message id="navigation.privacy" />
    </HeadingText>
  </div>
))

DataPrivacyHeader.displayName = 'DataPrivacyHeader'

export default DataPrivacyHeader
